import './components/ga-events';            //should be on top of each page's JS file
import './components/swipe-for-more';       // should be as soon as possible
import './components/css-properties-setter'; // should be as soon as possible
import './parts/navigation';
import './parts/keyboard-navigation';
import './parts/accept-cookies';
import './parts/ftc-disclosure';
import './components/accessibility-widget';
import './components/svg';
import Tooltips from './components/tooltips';

import './parts/range-with-output';
import '../vendor/splide.min';
import './components/js-links';
import './components/pagination';
import './widgets/accordion';
import './forms/partner-with-us';

import $ from 'cash-dom';
import CustomSelect from './components/custom-select';

/**
 * Dynamic module loading
 */
function initDynamicModules() {
	if (document.querySelector('.quiz-ui, .tiktok-quiz-ui, .ai-quiz-ui, .quiz-tiktok-social-ui, .quiz-us-social-1-ui, .ai-compact-quiz-ui')) {
		import('./parts/ppc/quiz').catch((err) => {
			console.error('Failed to dynamically load quiz module:', err);
		});
	}
}

initDynamicModules();

$(function () {
	Tooltips.getInstance().initOnce();
	CustomSelect.init();
});

if ($('#top_loans_carousel').length > 0) {
	new Splide('#top_loans_carousel').mount();
}

if ($('#posts_carousel').length > 0) {
	new Splide('#posts_carousel').mount();
}

if ($('#wc_news_chips').length > 0) {
	new Splide('#wc_news_chips').mount();
}

if ($('#wc_team_carousel').length > 0) {
	const teamCarousel = new Splide('#wc_team_carousel').mount();
	const teamElement = document.getElementById('wc_team_carousel');
	const rtl = getComputedStyle(teamElement).direction === 'rtl';
	let moving = false;
	let previousWheel = null;
	let lastSlideTime = 0;

	teamCarousel.on('move', () => {
		moving = true;
	});
	teamCarousel.on('moved', () => {
		moving = false;
	});

	//legacy's swiper `mousewheel` (Swiper 8.4.7, non-free mode), which Splide 2 has no equivalent of.
	//Every wheel event over the slider is consumed - a trackpad swipe must never become the browser's
	//back/forward gesture - and a slide is taken only on what reads as a new swipe: the first event, a
	//turn, a gap over 150ms, or a bigger delta than the last (a fresh flick inside the momentum tail)
	teamElement.addEventListener('wheel', (event) => {
		//ctrl+wheel and pinch are the browser's zoom
		if (event.ctrlKey) {
			return;
		}

		let x = event.deltaX;
		let y = event.deltaY;

		if (event.shiftKey && !x) {
			x = y;
			y = 0;
		}

		//line- and page-mode wheels (Firefox, some mice), scaled as swiper does
		if (event.deltaMode === 1) {
			x *= 40;
			y *= 40;
		} else if (event.deltaMode === 2) {
			x *= 800;
			y *= 800;
		}

		//negative is forward; a sideways swipe follows the fingers, so RTL mirrors it
		const delta = Math.abs(x) > Math.abs(y) ? (rtl ? x : -x) : -y;

		if (!delta) {
			return;
		}

		event.preventDefault();

		const wheel = {time: performance.now(), delta: Math.abs(delta), direction: Math.sign(delta)};
		const isNewSwipe = !previousWheel || wheel.direction !== previousWheel.direction ||
			wheel.delta > previousWheel.delta || wheel.time > previousWheel.time + 150;

		previousWheel = wheel;

		if (!isNewSwipe || (wheel.delta >= 6 && wheel.time - lastSlideTime < 60)) {
			return;
		}

		//as swiper: nothing while a slide animates (Splide 2's loop only re-anchors once a move ends)
		if (moving) {
			return;
		}

		lastSlideTime = wheel.time;
		teamCarousel.go(wheel.direction < 0 ? '>' : '<');
	}, {passive: false});
}


if ($('#posts_carousel_blue').length > 0) {
	const $track = $('#posts_carousel_blue').find('.splide__track > .splide__list');
	const $allSlides = $track.children('.splide__slide');
	$allSlides.detach();
	let matchedSlides = $allSlides.slice(0, 3);
	$track.append(matchedSlides);

	var postsSplide = new Splide('#posts_carousel_blue');
	postsSplide.mount();

	if ($('#cats_carousel').length > 0) {
		new Splide('#cats_carousel').mount();

		$('#cats_carousel .single-cat').on('click', function (e) {
			e.preventDefault();

			const catId = $(this).data('id');

			$('#cats_carousel .single-cat.active').removeClass('active');
			$(this).addClass('active');

			if ($allSlides) {
				$allSlides.detach();

				let matchedSlides = $allSlides.filter(function () {
					return $(this).find('.single-post').data('category') == catId;
				}).slice(0, 3);

				$track.append(matchedSlides);

				if (postsSplide) {
					postsSplide.destroy(true);
				}

				postsSplide = new Splide('#posts_carousel_blue');
				postsSplide.mount();
			}
		});
	}
}

(function () {
	if (!document.body.classList.contains('page-type-homepage')) {
		return;
	}
	var obs = new IntersectionObserver(function (entries) {
		entries.forEach(function (e) {
			if (e.isIntersecting) {
				e.target.classList.add('in');
				obs.unobserve(e.target);
			}
		});
	}, { threshold: 0.05, rootMargin: '0px 0px -40px 0px' });
	document.querySelectorAll('.reveal:not(.in)').forEach(function (el) {
		var r = el.getBoundingClientRect();
		if (r.top < window.innerHeight && r.bottom > 0) {
			el.classList.add('in');
		} else {
			obs.observe(el);
		}
	});
})();
